<template>
  <div class="page-box">
    <div class="title-box">
      <div class="icon-box"></div>
      设备实时状态详情
    </div>
    <div class="module-one-box">
      <div class="info-box">
        <div class="module-title-box">设备基础信息</div>
        <div class="content-box">
          <div class="row-box">
            设备状态：
            <div
              :style="
                infoData.isOnline == 0
                  ? 'color:#90EE90'
                  : 'color:rgb(211,211,211)'
              "
            >
              {{ $Common.getDataName(isOnlineList, infoData.isOnline) }}
            </div>
          </div>
          <div class="row-box">
            运行状态：
            <div
              :style="
                infoData.isBoot == 1
                  ? 'color:#90EE90'
                  : 'color:rgb(211,211,211)'
              "
            >
              {{ $Common.getDataName(isBootList, infoData.isBoot) }}
            </div>
          </div>
        </div>
      </div>
      <div class="tem-hum-box">
        <div class="module-title-box">温湿度实时监测</div>
        <div class="content-box">
          <div
            class="item-box"
            v-for="(item, index) in humTemData"
            :key="index"
          >
            <div class="value-box">
              {{ item.name1 }}{{ infoData[item.value1] }}{{ item.unit }}
            </div>
            <div class="status-box">
              {{ item.name2 }}
              <div
                :class="
                  infoData[item.value2] == 0
                    ? 'success-icon-box'
                    : 'error-icon-box'
                "
              >
                {{ $Common.getDataName(pduStatusList, infoData[item.value2]) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="module-two-box">
      <div class="module-title-box">电源输出实时监测</div>
      <div class="content-box">
        <div
          class="module-item-box"
          v-for="(item, index) in pduData"
          :key="index"
          :style="index == 2 ? 'border-style:none' : ''"
        >
          <div class="item-title-box">{{ item.title }}</div>
          <div class="item-content-box">
            <div class="item-box">
              <div class="img-box">
                <img
                  class="icon-box"
                  src="@/assets/img/safepostureSchool/icon-v.png"
                  alt=""
                />
              </div>
              <div class="value-status-box">
                <div class="value-box">{{ infoData[item.value1] }}V</div>
                <div class="status-box">
                  <div
                    :class="
                      infoData[item.status1] == 0
                        ? 'success-icon-box'
                        : 'error-icon-box'
                    "
                  >
                    {{
                      $Common.getDataName(pduStatusList, infoData[item.status1])
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="item-box">
              <div class="img-box">
                <img
                  class="icon-box"
                  src="@/assets/img/safepostureSchool/icon-a.png"
                  alt=""
                />
              </div>
              <div class="value-status-box">
                <div class="value-box">{{ infoData[item.value2] }}A</div>
                <div class="status-box">
                  <div
                    :class="
                      infoData[item.status2] == 0
                        ? 'success-icon-box'
                        : 'error-icon-box'
                    "
                  >
                    {{
                      $Common.getDataName(pduStatusList, infoData[item.status2])
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="item-box">
              <div class="img-box">
                <img
                  class="icon-box"
                  src="@/assets/img/safepostureSchool/icon-p.png"
                  alt=""
                />
              </div>
              <div class="value-status-two-box">
                {{ infoData[item.value3] }}W
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="module-three-box">
      <div class="module-item-box">
        <div class="module-title-box">IO输入实时监测</div>
        <div class="content-box">
          <div class="row-box">
            <div class="item-box">
              输入1状态：
              <div
                :class="
                  infoData.ioInput1Status == 0
                    ? 'success-icon-box'
                    : 'error-icon-box'
                "
              >
                {{
                  $Common.getDataName(pduStatusList, infoData.ioInput1Status)
                }}
              </div>
            </div>
            <div class="item-box">
              输入2状态：
              <div
                :class="
                  infoData.ioInput2Status == 0
                    ? 'success-icon-box'
                    : 'error-icon-box'
                "
              >
                {{
                  $Common.getDataName(pduStatusList, infoData.ioInput2Status)
                }}
              </div>
            </div>
          </div>
          <div class="row-box">
            <div class="item-box">
              输入3状态：
              <div
                :class="
                  infoData.ioInput3Status == 0
                    ? 'success-icon-box'
                    : 'error-icon-box'
                "
              >
                {{
                  $Common.getDataName(pduStatusList, infoData.ioInput3Status)
                }}
              </div>
            </div>
            <div class="item-box">
              输入4状态：
              <div
                :class="
                  infoData.ioInput4Status == 0
                    ? 'success-icon-box'
                    : 'error-icon-box'
                "
              >
                {{
                  $Common.getDataName(pduStatusList, infoData.ioInput4Status)
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="module-item-box">
        <div class="module-title-box">IO输出实时监测</div>
        <div class="content-box">
          <div class="row-box">
            <div class="item-box">
              输出1开关：
              <div
                :class="
                  infoData.ioOutput1Status == 0
                    ? 'success-icon-box'
                    : 'error-icon-box'
                "
              >
                {{
                  $Common.getDataName(ioOutputList, infoData.ioOutput1Status)
                }}
              </div>
            </div>
            <div class="item-box">
              输出2开关：
              <div
                :class="
                  infoData.ioOutput2Status == 0
                    ? 'success-icon-box'
                    : 'error-icon-box'
                "
              >
                {{
                  $Common.getDataName(ioOutputList, infoData.ioOutput2Status)
                }}
              </div>
            </div>
          </div>
          <div class="row-box">
            <div class="item-box">
              输出3开关：
              <div
                :class="
                  infoData.ioOutput3Status == 0
                    ? 'success-icon-box'
                    : 'error-icon-box'
                "
              >
                {{
                  $Common.getDataName(ioOutputList, infoData.ioOutput3Status)
                }}
              </div>
            </div>
            <div class="item-box">
              输出4开关：
              <div
                :class="
                  infoData.ioOutput4Status == 0
                    ? 'success-icon-box'
                    : 'error-icon-box'
                "
              >
                {{
                  $Common.getDataName(ioOutputList, infoData.ioOutput4Status)
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="module-item-box">
        <div class="module-title-box">其他实时监测</div>
        <div class="content-box">
          <div class="row-box">
            <div class="item-box">
              市电状态：
              <div
                :class="
                  infoData.electricStatus == 0
                    ? 'success-icon-box'
                    : 'error-icon-box'
                "
              >
                {{
                  $Common.getDataName(pduStatusList, infoData.electricStatus)
                }}
              </div>
            </div>
            <div class="item-box">
              电温状态：
              <div
                :class="
                  infoData.wireStatus == 0
                    ? 'success-icon-box'
                    : 'error-icon-box'
                "
              >
                {{ $Common.getDataName(pduStatusList, infoData.wireStatus) }}
              </div>
            </div>
            <div class="item-box">
              电源输入状态：
              <div
                :class="
                  infoData.pduInStatus == 0
                    ? 'success-icon-box'
                    : 'error-icon-box'
                "
              >
                {{ $Common.getDataName(pduStatusList, infoData.pduInStatus) }}
              </div>
            </div>
          </div>
          <div class="row-box">
            <div class="item-box">
              水浸状态：
              <div
                :class="
                  infoData.waterStatus == 0
                    ? 'success-icon-box'
                    : 'error-icon-box'
                "
              >
                {{ $Common.getDataName(pduStatusList, infoData.waterStatus) }}
              </div>
            </div>
            <div
              class="item-box"
              style="color: rgb(250, 212, 3);font-size: 18px;"
            >
              电线温度：{{ infoData.wireValue }}℃
            </div>

            <div class="item-box">
              12V电源输出状态：
              <div
                :class="
                  infoData.pduOutStatus == 0
                    ? 'success-icon-box'
                    : 'error-icon-box'
                "
              >
                {{ $Common.getDataName(pduStatusList, infoData.pduOutStatus) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="module-four-box">
      <div class="module-title-box">USB实时监测</div>
      <div class="content-box">
        <div class="item-box" v-for="(item,index) in 24" :key="index">
          USB{{item}}状态：
          <div
                :class="
                  infoData['usb'+item+'Status'] == 0
                    ? 'success-icon-box'
                    : 'error-icon-box'
                "
              >
                {{ $Common.getDataName(pduStatusList, infoData['usb'+item+'Status']) }}
              </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {},
  data() {
    //这里存放数据
    return {
      websock: null,
      infoData: {
        isBoot: 1, //运行状态
        isOnline: 0, //设备状态
        hum1Value: "45.6", //湿度1值
        hum1Status: 0, //湿度1状态
        hum2Value: "44.7", //湿度2值
        hum2Status: 0, //湿度2状态
        tem1Value: "22.1", //温度1值
        tem1Status: 0, //温度1状态
        tem2Value: "23.0", //温度2值
        tem2Status: 0, //温度2状态
        pdu1aStatus: 0, //电源1输出电流状态 0正常 1异常
        pdu1vStatus: 0, //电源1输出电压状态 0正常 1异常
        pdu2aStatus: 0, //电源2输出电流状态 0正常 1异常
        pdu2vStatus: 0, //电源2输出电压状态 0正常 1异常
        pdu3aStatus: 0, //电源3输出电流状态 0正常 1异常
        pdu3vStatus: 0, //电源3输出电压状态 0正常 1异常
        pdu1aValue: "0.0", //电源1电流
        pdu1vValue: "229", //电源1电压
        pdu1wValue: "0.0", //电源1电功率
        pdu2aValue: "0.0", //电源2电流
        pdu2vValue: "229", //电源2电压
        pdu2wValue: "0.0", //电源2电功率
        pdu3aValue: "0.0", //电源3电流
        pdu3vValue: "229", //电源3电压
        pdu3wValue: "0.0", //电源3电功率
        pduInStatus: 0, //电源输入状态 0正常 1异常
        pduOutStatus: 0, //12V电源输出状态 0正常 1异常
        ioInput1Status: 0, //IO输入1状态 0正常 1异常
        ioInput2Status: 0, //IO输入2状态 0正常 1异常
        ioInput3Status: 0, //IO输入3状态 0正常 1异常
        ioInput4Status: 0, //IO输入4状态 0正常 1异常
        ioOutput1Status: 0, //IO输出1状态 0开启 1关闭
        ioOutput2Status: 0, //IO输出2状态 0开启 1关闭
        ioOutput3Status: 0, //IO输出3状态 0开启 1关闭
        ioOutput4Status: 0, //IO输出4状态 0开启 1关闭
        electricStatus: 0, //市电状态 0正常 1异常
        waterStatus: 0, //水浸状态 0正常 1异常
        wireStatus: 0, //电线温度状态 0正常 1异常
        wireValue: "22.6", //电线温度
        usb1Status:0,
        usb2Status:0,
        usb3Status:0,
        usb4Status:0,
        usb5Status:0,
        usb6Status:0,
        usb7Status:0,
        usb8Status:0,
        usb9Status:0,
        usb10Status:0,
        usb11Status:0,
        usb12Status:0,
        usb13Status:0,
        usb14Status:0,
        usb15Status:0,
        usb16Status:0,
        usb17Status:0,
        usb18Status:0,
        usb19Status:0,
        usb20Status:0,
        usb21Status:0,
        usb22Status:0,
        usb23Status:0,
        usb24Status:0,
      },
      humTemData: [
        {
          name1: "温度1：",
          value1: "tem1Value",
          unit: "℃",
          name2: "温度1状态：",
          value2: "tem1Status"
        },
        {
          name1: "温度2：",
          value1: "tem2Value",
          unit: "℃",
          name2: "温度2状态：",
          value2: "tem2Status"
        },
        {
          name1: "湿度1：",
          value1: "hum1Value",
          unit: "%Rh",
          name2: "湿度1状态：",
          value2: "hum1Status"
        },
        {
          name1: "湿度2：",
          value1: "hum2Value",
          unit: "%Rh",
          name2: "湿度2状态：",
          value2: "hum2Status"
        }
      ],
      pduData: [
        {
          title: "电源1开关",
          value1: "pdu1aValue",
          status1: "pdu1aStatus",
          value2: "pdu1vValue",
          status2: "pdu1vStatus",
          value3: "pdu1wValue"
        },
        {
          title: "电源2开关",
          value1: "pdu2aValue",
          status1: "pdu2aStatus",
          value2: "pdu2vValue",
          status2: "pdu2vStatus",
          value3: "pdu2wValue"
        },
        {
          title: "电源3开关",
          value1: "pdu3aValue",
          status1: "pdu3aStatus",
          value2: "pdu3vValue",
          status2: "pdu3vStatus",
          value3: "pdu3wValue"
        }
      ]
    };
  },
  //监控data中的数据变化
  watch: {},
  //计算属性，类似于data概念
  computed: {
    isBootList() {
      return [
        { id: 0, name: "关机" },
        { id: 1, name: "开机" }
      ];
    },
    isOnlineList() {
      return [
        { id: 0, name: "在线" },
        { id: 1, name: "掉线" }
      ];
    },
    pduStatusList() {
      return [
        { id: 0, name: "正常" },
        { id: 1, name: "报警" }
      ];
    },
    ioOutputList() {
      return [
        { id: 0, name: "开启" },
        { id: 1, name: "关闭" }
      ];
    }
  },
  //方法集合
  methods: {
    initWebSocket() {
      //初始化weosocket
      let params =
        "?schoolId=" +
        this.$store.state.schoolId +
        "&deviceNum=" +
        this.$route.query.deviceNum +
        "&type=0";
      let wsuri =
        this.$store.state.config.wsIpConfig +
        "/webscoket/environment/monitor/ty" +
        params;
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
      // let actions = {};
      // this.websocketsend(actions);
    },
    websocketonerror() {
      //连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) {
      //数据接收
      let res = JSON.parse(e.data);
      switch (res.type) {
          case 0:
            this.infoData.isBoot = res.data.isBoot
            break;
          case 1:
            this.infoData.electricStatus = res.data.ewwOtherStatus.electricStatus
            this.infoData.waterStatus = res.data.ewwOtherStatus.waterStatus
            this.infoData.wireStatus = res.data.ewwOtherStatus.wireStatus
            this.infoData.ioInput1Status = res.data.ioInput.ioInput1Status
            this.infoData.ioInput2Status = res.data.ioInput.ioInput2Status
            this.infoData.ioInput3Status = res.data.ioInput.ioInput3Status
            this.infoData.ioInput4Status = res.data.ioInput.ioInput4Status
            this.infoData.ioOutput1Status = res.data.ioOutput.ioOutput1Status
            this.infoData.ioOutput2Status = res.data.ioOutput.ioOutput2Status
            this.infoData.ioOutput3Status = res.data.ioOutput.ioOutput3Status
            this.infoData.ioOutput4Status = res.data.ioOutput.ioOutput4Status
            this.infoData.pdu1aStatus = res.data.pduStatus.pdu1aStatus
            this.infoData.pdu1vStatus = res.data.pduStatus.pdu1vStatus
            this.infoData.pdu2aStatus = res.data.pduStatus.pdu2aStatus
            this.infoData.pdu2vStatus = res.data.pduStatus.pdu2vStatus
            this.infoData.pdu3aStatus = res.data.pduStatus.pdu3aStatus
            this.infoData.pdu3vStatus = res.data.pduStatus.pdu3vStatus
            this.infoData.pduInStatus = res.data.pduStatus.pduInStatus
            this.infoData.pduOutStatus = res.data.pduStatus.pduOutStatus
            this.infoData.hum1Status = res.data.temHumStatus.hum1Status
            this.infoData.hum2Status = res.data.temHumStatus.hum2Status
            this.infoData.tem1Status = res.data.temHumStatus.tem1Status
            this.infoData.tem2Status = res.data.temHumStatus.tem2Status
            for (let index = 0; index < 24; index++) {
              this.infoData['usb'+ (index + 1) +'Status'] = res.data.usb['usb'+ (index + 1) +'Status']
            }
            break;
            case 2:
              this.infoData.isOnline = res.data.isOnline
            break;
            case 3:
              this.infoData.electricStatus = res.data.electricStatus
            break;
            case 4:
              this.infoData.pdu1aValue = res.data.pdu1a ? res.data.pdu1a : this.infoData.pdu1aValue
              this.infoData.pdu1vValue = res.data.pdu1v ? res.data.pdu1v : this.infoData.pdu1vValue
              this.infoData.pdu1wValue = res.data.pdu1w ? res.data.pdu1w : this.infoData.pdu1wValue
              this.infoData.pdu2aValue = res.data.pdu2a ? res.data.pdu2a : this.infoData.pdu2aValue
              this.infoData.pdu2vValue = res.data.pdu2v ? res.data.pdu2v : this.infoData.pdu2vValue
              this.infoData.pdu2wValue = res.data.pdu2w ? res.data.pdu2w : this.infoData.pdu2wValue
              this.infoData.pdu3aValue = res.data.pdu3a ? res.data.pdu3a : this.infoData.pdu3aValue
              this.infoData.pdu3vValue = res.data.pdu3v ? res.data.pdu3v : this.infoData.pdu3vValue
              this.infoData.pdu3wValue = res.data.pdu3w ? res.data.pdu3w : this.infoData.pdu3wValue
            break;
            case 5:
              this.infoData.hum1Value = res.data.hum1 ? res.data.hum1 : this.infoData.hum1Value
              this.infoData.hum2Value = res.data.hum2 ? res.data.hum2 : this.infoData.hum2Value
              this.infoData.tem1Value = res.data.tem1 ? res.data.tem1 : this.infoData.tem1Value
              this.infoData.tem2Value = res.data.tem2 ? res.data.tem2 : this.infoData.tem2Value
            break;
            case 6:
              this.infoData.ioInput1Status = res.data.ioInput1Status
              this.infoData.ioInput2Status = res.data.ioInput2Status
              this.infoData.ioInput3Status = res.data.ioInput3Status
              this.infoData.ioInput4Status = res.data.ioInput4Status
            break;
            case 7:
              this.infoData.wireValue = res.data.wire
            break;
        }
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    },
    websocketclose(e) {
      //关闭
      console.log("断开连接", e);
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {
    // this.initWebSocket();
  },
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {
    this.websock.close(); //离开路由之后断开websocket连接
  }, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
var targetHeightScale; //存放缩放的比例
var autoResize = {
  resize: function(docWidth, docHeight, targetSelector) {
    var docScale = docHeight / docWidth,
      designWidth = 1920,
      designHeight = 940,
      els = document.querySelectorAll(targetSelector),
      scale = docWidth / designWidth,
      scaleX = docWidth / designWidth,
      scaleY = docHeight / designHeight,
      _this = this;
    (targetHeightScale = scale), //将缩放比例保存，动态计算宽高时需要使用
      this.convertArray(els).forEach(function(el) {
        _this.extend(el.style, {
          width: designWidth + "px",
          height: docScale * designWidth + "px",
          position: "absolute",
          top: 0,
          left: 0,
          transformOrigin: "0 0",
          webkitTransformOrigin: "0 0",
          transform: "scale(" + scale + ")",
          webkitTransform: "scale(" + scale + ")",
          overflow: "hidden",
          webkitOverflowScrolling: "touch"
        });
      });
  },
  convertArray: function(arrayLike) {
    return Array.prototype.slice.call(arrayLike, 0);
  },
  extend: function() {
    var args = Array.prototype.slice.call(arguments, 0);
    return args.reduce(function(prev, now) {
      for (var key in now) {
        if (now.hasOwnProperty && now.hasOwnProperty(key)) {
          prev[key] = now[key];
        }
      }
      return prev;
    });
  },
  scaleResize: function(clientWidth, clientHeight, targetSelector) {
    window.addEventListener(
      "resize",
      this.resize(clientWidth, clientHeight, targetSelector)
    ); //监听窗口的变化
  }
};
var setElementSize = {
  //参数可选，最多选择5个参数。参数按序赋值，如果不需缩放，scale需传入1
  setSize: function(target, scale, target1, target2, target3) {
    var targetScale = scale || 1; //不传scale，不缩放，默认为1
    var targetHeight;
    if (target) {
      targetHeight = innerHeight / targetScale;
    }
    // console.log(targetHeight)
    // if (target1) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height();
    // }
    // if (target1 && target2 && target3) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height() -  document.querySelector(target2).height() -  document.querySelector(target3).height();
    // } else if (target1 && target2) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height() -  document.querySelector(target2).height();
    // } else if (target1) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height();
    // }
    document.querySelector(".bigdata_page").style.height = targetHeight;

    // var cancas =  document.getElementsByTagName('canvas')
    // var ss = document.getElementsByTagName('canvas')

    // console.log(ss)

    // document.getElementsByTagName('canvas').setAttribute('height','100%')
    // document.getElementsByTagName('canvas').setAttribute('width','100%')
    // console.log(cancas)
    // cancas.width = '100px'
    // cancas.height = '100px'

    // console.log(123)
    // console.log(document.querySelector('.bigdata_page').offsetHeight)
  }
};
var is_fullScreen = false;

window.onresize = function() {
  if (is_fullScreen) {
    changeHeight();
  } else {
    cancelChangeHeight();
  }
  autoResize.scaleResize(innerWidth, innerHeight, ".bigdata_page");
  setElementSize.setSize(".bigdata_page", targetHeightScale);
  // setElementSize.setSize('.left_top', targetHeightScale, '.top')
  // setElementSize.setSize('.map', targetHeightScale, '.top', '.left_bottom');
  // setElementSize.setSize('.right_body', targetHeightScale, '.top');
};
autoResize.scaleResize(innerWidth, innerHeight, ".bigdata_page");
setElementSize.setSize(".bigdata_page", targetHeightScale);
// 全屏状态时更改高度
function changeHeight() {
  is_fullScreen = true;
}

// 取消全屏时恢复
function cancelChangeHeight() {
  is_fullScreen = false;
}
</script>
<style scoped lang="scss">
.page-box {
  width: 100%;
  height: 100%;
  background-color: rgb(34, 34, 51);
  padding: 10px 20px;
}
.title-box {
  width: 100%;
  background-color: rgb(51, 51, 85);
  height: 40px;
  padding-left: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: rgb(61, 110, 198);
  font-size: 20px;
  .icon-box {
    width: 2px;
    height: 70%;
    background-color: rgb(61, 110, 198);
    margin-right: 10px;
  }
}
.module-title-box {
  width: 100%;
  height: 40px;
  font-size: 18px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #fff;
  padding-left: 10px;
  background-color: rgb(51, 51, 85);
}
.module-one-box {
  margin-top: 10px;
  width: 100%;
  height: 160px;
  display: flex;
  .info-box {
    width: 300px;
    height: 100%;
    .content-box {
      width: 100%;
      height: 120px;
      background-color: rgb(34, 51, 85);
      .row-box {
        width: 100%;
        height: 50px;
        color: #fff;
        padding-left: 20px;
        display: flex;
        align-items: center;
      }
    }
  }
  .tem-hum-box {
    margin-left: 20px;
    width: calc(100% - 320px);
    height: 100%;
    .content-box {
      width: 100%;
      height: 120px;
      background-color: rgb(34, 51, 85);
      display: flex;
      justify-content: space-between;
      .item-box {
        width: 25%;
        height: 100%;
        .value-box {
          width: 100%;
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: rgb(250, 212, 3);
          font-size: 24px;
        }
        .status-box {
          width: 100%;
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
        }
      }
    }
  }
}
.module-two-box {
  margin-top: 10px;
  width: 100%;
  height: 240px;
  .content-box {
    width: 100%;
    height: 200px;
    background-color: rgb(34, 51, 85);
    display: flex;
    justify-content: space-between;
    .module-item-box {
      width: 33%;
      height: 100%;
      border-width: 0.5px;
      border-color: rgba(255, 255, 255, 0.6);
      border-style: none dashed none none;
      .item-title-box {
        width: 100%;
        height: 50px;
        color: #fff;
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
      }
      .item-content-box {
        width: 100%;
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .item-box {
          width: 32%;
          height: 100%;
          display: flex;
          .img-box {
            width: 50%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            .icon-box {
              width: 60px;
              height: 60px;
            }
          }
          .value-status-box {
            height: 100%;
            width: 50%;
            .value-box {
              width: 100%;
              height: 50%;
              display: flex;
              justify-content: center;
              align-items: flex-end;
              color: rgb(250, 212, 3);
              font-size: 20px;
            }
            .status-box {
              margin-top: 10px;
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: flex-start;
            }
          }
          .value-status-two-box {
            height: 100%;
            width: 50%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: rgb(250, 212, 3);
            font-size: 20px;
          }
        }
      }
    }
  }
}
.module-three-box {
  margin-top: 10px;
  width: 100%;
  height: 180px;
  display: flex;
  justify-content: space-between;
  .module-item-box {
    width: 33%;
    height: 100%;
    .content-box {
      width: 100%;
      height: 140px;
      background-color: rgb(34, 51, 85);
      .row-box {
        width: 100%;
        height: 70px;
        display: flex;
        align-items: center;
        .item-box {
          width: 50%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          font-size: 14px;
        }
      }
    }
  }
}
.module-four-box {
  margin-top: 10px;
  width: 100%;
  height: calc(100% - 660px);
  .content-box {
    width: 100%;
    height: calc(100% - 40px);
    background-color: rgb(34, 51, 85);
    display: grid;
    grid-template-columns: repeat(6, 1fr); /* 相当于 1fr 1fr 1fr */
    grid-template-rows: repeat(4, 1fr); /* fr单位可以将容器分为几等份 */
    grid-gap: 10px; /* grid-column-gap 和 grid-row-gap的简写 */
    grid-auto-flow: row;
    .item-box{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
    }
  }
}
.success-icon-box {
  width: 80px;
  height: 30px;
  border-radius: 6px;
  background-color: rgb(65, 201, 171);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 14px;
}
.error-icon-box {
  width: 80px;
  height: 30px;
  border-radius: 6px;
  background-color: rgb(236, 73, 73);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 14px;
  animation: fade 600ms infinite;
    -webkit-animation: fade 600ms infinite;
}
@keyframes fade {
    from {
        opacity: 1.0;
    }
    50% {
        opacity: 0.4;
    }
    to {
        opacity: 1.0;
    }
}

@-webkit-keyframes fade {
    from {
        opacity: 1.0;
    }
    50% {
        opacity: 0.4;
    }
    to {
        opacity: 1.0;
    }
}
</style>
